import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./context/I18nContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsappButton from "./components/WhatsappButton";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { api } from "./lib/api";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout({ children, settings }) {
  return (
    <>
      <Navbar settings={settings} />
      <main>{children}</main>
      <Footer settings={settings} />
      <WhatsappButton settings={settings} />
    </>
  );
}

function AdminLayout({ children, settings }) {
  return (
    <>
      <Navbar settings={settings} />
      {children}
    </>
  );
}

export default function App() {
  const [settings, setSettings] = useState(null);

  const refreshSettings = () =>
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));

  useEffect(() => { refreshSettings(); }, []);

  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<PublicLayout settings={settings}><Home settings={settings} /></PublicLayout>} />
              <Route path="/about" element={<PublicLayout settings={settings}><About settings={settings} /></PublicLayout>} />
              <Route path="/services" element={<PublicLayout settings={settings}><Services settings={settings} /></PublicLayout>} />
              <Route path="/gallery" element={<PublicLayout settings={settings}><Gallery settings={settings} /></PublicLayout>} />
              <Route path="/contact" element={<PublicLayout settings={settings}><Contact settings={settings} /></PublicLayout>} />
              <Route path="/admin/login" element={<AdminLayout settings={settings}><AdminLogin /></AdminLayout>} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout settings={settings}>
                      <AdminDashboard onSettingsSaved={refreshSettings} />
                    </AdminLayout>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}
